import React, { Component } from 'react';
import Linkify from 'linkifyjs/react';

import {Button, Dialog} from '@betareader/design-system';
import AppIcon from '../../components/AppIcon';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import ReactMarkdown from 'react-markdown';
import { withRouter } from 'react-router-dom';
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchInboxes
} from '../../modules/manuscriptInbox';
import { authUtil, uxAnalyticsUtil } from '../../utils';
import BookItem from '../../components/book/bookItem';
import {
  fetchCurrentBook,
  resetCurrentBook
} from '../../modules/book';
import { CenteredContent } from '../../style';

const receiptMarkdownComponents = {
  a: ({href, title, children}) => (
    <a href={href} title={title} target='_blank' rel='noopener noreferrer'>{children}</a>
  ),
};

export class ManuscriptSubmission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false
    };
  }

  componentDidMount() {
    this.setup();
    this.getInboxes();
    uxAnalyticsUtil.trackPageView(this.props.match.path);
  }

  componentDidUpdate(prevProps) {
    const { currentBook } = this.props;
    if (!currentBook && prevProps.currentBook) {
      this.setup();
    }
  }

  componentWillUnmount() {
    this.props.resetCurrentBook();
  }

  getInboxes = async () => {
      const idToken = await authUtil.getFreshIdToken();
    this.props.fetchInboxes(idToken);
  }

  setup = async () => {
    const {
      t, match, currentBook, location
    } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    const { bookId } = queryString.parse(location.search);
    if (bookId !== 'first' && (!currentBook || currentBook._id !== bookId)) {
      this.props.resetCurrentBook();
      this.props.fetchCurrentBook({ idToken, bookId }, (result) => {
        if (result.errorMessage) {
          this.setState({
            errorMessage: t(result.errorMessage)
          });
        }
      });
    }
  }

  submitManuscriptToInbox = async (e) => {
    const inboxData = e.currentTarget.dataset;
    const { t, currentBook, userProfile } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    uxAnalyticsUtil.trackEvent({
      category: 'Manuscript-inbox',
      action: 'clicked-submit-manuscript',
      label: inboxData.inboxId
    });
    const postData = {
      book: currentBook._id,
      to: inboxData.inboxId,
      from: userProfile.account._id
    };
    this.setState({ sending: inboxData.inboxId });
    fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/manuscript-inbox/submissions`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'br-token': idToken
        },
        body: JSON.stringify(postData)
      })
      .then((res) => {
        if (!res.ok) {
          throw new Error(res.error);
        } else {
          return res.json();
        }
      })
      .then((submission) => {
        this.setState({
          success: inboxData.inboxId,
          showMsg: {
            markdown: inboxData.receiptMessageMarkdown
          }
        });

        toast.success(t('ManuscriptSubmissionSuccess'));
      })
      .catch((err) => {
        toast.error(t('FailedToSend', err));
      })
      .finally(() => {
        this.setState({ sending: false });
      });
  }

  goToBook = event => {
    event.stopPropagation();
    this.props.changePage(`/books/${event.currentTarget.dataset.bookId}`);
  }

  goToMyManuscripts = () => {
    this.props.changePage('/mymanuscripts');
  }

  hasSubmitted = ({ inbox, bookId }) => {
    const hasSubmitted = inbox.submissions.length > 0
        && inbox.submissions.filter(submission => submission.book?._id === bookId).length === 1;
    return hasSubmitted;
  }

  canSubmitToInbox = ({ book, inbox }) => {
    if (!book || book.privacy === 'unpublished' || !inbox.enabled) {
      return false;
    }
    if (this.hasSubmitted({ inbox, bookId: book._id })) {
      return false;
    }
    return true;
  }

  render() {
    const { t, inboxes, currentBook } = this.props;
    const { sending, success, showMsg } = this.state;
    if (inboxes.length > 0) {
      return (
        <CenteredContent>
          <div>
            { currentBook ? (
              <BookItem
                key={currentBook._id}
                book={currentBook}
                isAuthor
              />
            ) : <Button onClick={this.goToMyManuscripts}>{t('SelectManuscriptToSubmit')}</Button>
          }
          </div>
          <h2>{t('SubmitTo')}</h2>
          <ul style={{listStyle: 'none', padding: 0}}>
            {
              inboxes.map((inbox) => {
                const canSubmitToInbox = this.canSubmitToInbox({
                  book: currentBook, inbox
                });
                return (
                  <li key={inbox._id} style={{borderBottom: '1px solid var(--br-border)',
                    padding: '1rem 0'}}>
                    <div style={{display: 'flex', alignItems: 'flex-start', gap: 12}}>
                      <AppIcon name='inbox' size='large' />
                      <div style={{flex: 1, minWidth: 0}}>
                        <h3>{inbox.title}</h3>
                        <p style={{whiteSpace: 'pre-wrap'}}><Linkify>{inbox.description}</Linkify></p>
                      </div>
                      {
                        success === inbox._id
                          ? <span role='status' aria-label={t('ManuscriptSubmissionSuccess')}>
                            <AppIcon name='check circle' color='green' size='large' />
                          </span>
                          : (
                            <Button
                              data-inbox-id={inbox._id}
                              data-receipt-message-markdown={inbox.receiptMessageMarkdown}
                              onClick={this.submitManuscriptToInbox}
                              disabled={!canSubmitToInbox || sending === inbox._id}
                              aria-busy={sending === inbox._id}>
                              {t('Submit')}
                            </Button>
                          )
                      }
                    </div>
                    {inbox.submissions.length > 0 && <div>
                      <span>{t('YourSubmittedManuscripts')}: </span>
                      {inbox.submissions.map(submission => submission.book && (
                        <Button key={submission._id} variant='secondary' size='small'
                          data-book-id={submission.book._id} onClick={this.goToBook}>
                          {submission.book.title}
                        </Button>
                      ))}
                    </div>}
                  </li>
                );
              })
            }
          </ul>
          <Dialog open={!!showMsg} title={t('ManuscriptSubmissionSuccess')}
            onClose={() => this.setState({showMsg: false})}
            actions={<Button onClick={() => this.setState({showMsg: false})}>{t('Close')}</Button>}>
            {showMsg && <ReactMarkdown components={receiptMarkdownComponents}>{showMsg.markdown}</ReactMarkdown>}
          </Dialog>
        </CenteredContent>
      );
    }
    return (
      <CenteredContent>
        <p>{t('NothingHere')}</p>
      </CenteredContent>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  userProfile: state.user.userProfile,
  inboxes: state.manuscriptInbox.inboxes,
  currentBook: state.book.currentBook
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchInboxes,
  fetchCurrentBook,
  resetCurrentBook,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ManuscriptSubmission)));
